export default __webpack_public_path__ + "static/media/notificationsound.c454b8ce.mp3";